"use client";

import { useState, type ReactNode } from "react";
import SwitchTabs from "./SwitchTabs";

type Tab = "featured" | "latest";
type Variant = "default" | "mono";

interface Props {
    title?: string;
    featuredLabel: string;
    latestLabel: string;
    featured: ReactNode;
    latest: ReactNode;
    variant?: Variant;
    defaultTab?: Tab;
}

const titleClass: Record<Variant, string> = {
    default: "text-sm font-medium uppercase tracking-wide text-muted-foreground",
    mono: "font-mono text-[11px] uppercase tracking-widest text-muted-foreground",
};

const wrapperMargin: Record<Variant, string> = {
    default: "mb-2",
    mono: "mb-3",
};

export default function ProjectsTabs({
    title,
    featuredLabel,
    latestLabel,
    featured,
    latest,
    variant = "default",
    defaultTab = "featured",
}: Props) {
    const [tab, setTab] = useState<Tab>(defaultTab);
    const [hasInteracted, setHasInteracted] = useState(false);

    return (
        <>
            <header
                className={`${wrapperMargin[variant]} flex items-center ${title ? "justify-between" : "justify-end"} gap-3`}
            >
                {title ? <h2 className={titleClass[variant]}>{title}</h2> : null}
                <SwitchTabs
                    options={[
                        { value: "featured", label: featuredLabel },
                        { value: "latest", label: latestLabel },
                    ]}
                    value={tab}
                    onChange={(next) => {
                        setHasInteracted(true);
                        setTab(next);
                    }}
                />
            </header>
            <div key={tab} className={hasInteracted ? "tab-content-enter" : undefined}>
                {tab === "featured" ? featured : latest}
            </div>
        </>
    );
}
